import { BoxProps } from '@mui/system'
import { Box, Container } from '@mui/material'
import { ReactChildren } from '@/types'

type PageBodyLayoutProps = Partial<BoxProps> &
  ReactChildren & { fullWidth?: boolean }

export const PageBodyLayout = ({
  children,
  fullWidth = false,
  ...rest
}: PageBodyLayoutProps): JSX.Element => (
  <Box
    py={{ xs: 5, md: 10 }}
    borderRadius={5}
    bgcolor="white"
    flex={1}
    {...rest}
  >
    <Container maxWidth={fullWidth ? false : 'xl'}>{children}</Container>
  </Box>
)
